import { RouteObject } from "react-router-dom";
import { UsersList } from "../pages/admin/users/UsersList";
import { UserDetail } from "../pages/admin/users/UserDetail";
import { UserCreate } from "../pages/admin/users/UserCreate";
import { UserEdit } from "../pages/admin/users/UserEdit";

export const usersRoutes: RouteObject[] = [
  { id: "users-list", index: true, element: <UsersList /> },
  { id: "user-detail", path: ":id", element: <UserDetail /> },
  { id: "user-create", path: "create", element: <UserCreate /> },
  { id: "user-edit", path: ":id/edit", element: <UserEdit /> },
];
